import React from 'react';
import { toast } from 'react-toastify';
import GuidesAndResources from '../../../Shared/GuidesAndResources';
import AssemblyPlans from '../../../Shared/AssemblyPlans';
import PlaylistCards from '../../../Shared/PlaylistCards';
import Songbooks from '../../../Shared/Songbook/Index';
import SongCards from '../../../Shared/SongCards/Index';
import useGetCategoryPage from '../../../../hooks/useGetCategoryPage';

const MainSection = ({
  songs,
  resources,
  displayResources = true,
  displaySongs = true,
  displayPlaylists = true,
  displaySongbooks = true,
  filterParams,
}) => {
  const { data, loading } = useGetCategoryPage('wellbeing');
  loading && toast.info('Loading...', { toastId: 'loading' });

  return (
    <section className="main__container mt__lg-50 mt-40">
      <div className="px__sm-3">
        {displaySongs && (
          <SongCards
            title="Wellbeing Songs"
            songs={songs}
            pageTitle="Wellbeing"
            name="Wellbeing"
            type="OOTA Singing School"
            filterParams={filterParams}
          />
        )}
        {displayResources && (
          <GuidesAndResources
            resources={resources}
            title="Wellbeing"
            type="OOTA Singing School"
          />
        )}
        {displayPlaylists && (
          <PlaylistCards
            playlists={data?.categoryPage?.playlists}
            title="Wellbeing playlists"
            disableDeletePlaylist
          />
        )}
      </div>
      {displaySongbooks && (
        <Songbooks songbooks={data?.categoryPage?.esongbooks} />
      )}
      <AssemblyPlans />
    </section>
  );
};

export default MainSection;
